import { Field } from 'formik'
import React from 'react'

import { Fieldset, RadioButton, Subsection } from '@fourthwall/components'

import { FormFields, Usage } from '../../types'

type Props = {
  disabled?: boolean
}

export const CommonFields = ({ disabled }: Props) => (
  <Subsection title="Welcome post">
    <Fieldset>
      <Fieldset.Row>
        <Fieldset.Item>
          Show your members a little love with a personal welcome post that appears to your
          supporters when they join.
        </Fieldset.Item>
      </Fieldset.Row>
      <Fieldset.Row>
        <Field
          name={FormFields.usage}
          component={RadioButton}
          label="Don’t use welcome post"
          checkedValue={Usage.none}
          disabled={disabled}
        />
      </Fieldset.Row>
      <Fieldset.Row>
        <Field
          name={FormFields.usage}
          component={RadioButton}
          label="Use the same welcome post for each tier"
          checkedValue={Usage.same}
          disabled={disabled}
        />
      </Fieldset.Row>
      <Fieldset.Row>
        <Field
          name={FormFields.usage}
          component={RadioButton}
          label="Use different welcome post for each tier"
          checkedValue={Usage.different}
          disabled={disabled}
        />
      </Fieldset.Row>
    </Fieldset>
  </Subsection>
)
